export default function footerMenu() {
    const menuToggles = document.querySelectorAll('.footer__col--services li.menu-item-has-children > a');

    menuToggles.forEach((toggle) => {
        toggle.addEventListener('click', (e) => {
            e.preventDefault();
            const subMenu = toggle.nextElementSibling;
            const parent = toggle.parentElement;
            parent.classList.toggle('active');

            if (subMenu) {
                subMenu.classList.toggle('active');
            }
        });
    });
}
